import React from 'react';
import { translate } from 'react-i18next';

import * as CostCenter from 'cost_centers/components/form';
import * as Common from 'common/components';

const CostCenterFormView = ({
  t,
  costCenter,
  company,
  handleAddYear,
  handleRemoveYear,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  isSubmitted,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("menu.configuration")+" > " + t("costCenters.costCenters_title") + " > " +t("costCenters.costCenters_title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('costCenters.costCenters_title') +
          ' > ' +
          t(costCenter.id ? 'costCenters.edit' : 'costCenters.add')
        }
        icon={'book'}
      >
        <CostCenter.Form
          company={company}
          handleAddYear={handleAddYear}
          handleRemoveYear={handleRemoveYear}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSaving={isSaving}
          isSubmitted={isSubmitted}
          subcompany={subcompany}
          values={costCenter}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(CostCenterFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/CostCenterFormView.js